import { DataModel } from '../../models/dto/dto.js';
import { compareTo } from '../../utility/comparison.js';

export abstract class Component extends DataModel {
  private static _totalNumberOfCreatedComponents = 0;

  public readonly _instanceId: string;

  constructor() {
    super();

    this._instanceId = this.generateInstanceId();
  }

  abstract get $removable(): boolean

  private generateInstanceId(): string {
    return `${this.$displayName}_${++Component._totalNumberOfCreatedComponents}`;
  }

  get $instanceId(): string {
    return this._instanceId;
  }

  get $displayName(): string {
    return this.constructor.name;
  }

  toString(): string {
    return this._instanceId;
  }
}

export abstract class RenderableComponent extends Component {
  abstract get isRenderingEnabled(): boolean
  abstract set isRenderingEnabled(value: boolean)

  abstract get renderOrder(): number;
  abstract set renderOrder(value: number);

  compareTo(other: this): number {
    return compareTo(this.renderOrder, other.renderOrder);
  }
}
